//angular imports
import { signal, WritableSignal } from "@angular/core";

//local imports
import { AppAvailabilityDto } from "@core/data/http";
import { Key } from "@core/helpers";

export class AppAvailability
{
  public catalog: WritableSignal<boolean>;
  public library: WritableSignal<boolean>;

  @Key('service-matrix')
  public servicesMatrix: WritableSignal<boolean>;

  @Key('space-bot')
  public spaceBot: WritableSignal<boolean>;
  public security: WritableSignal<boolean>;
  public tracker: WritableSignal<boolean>;
  public marketplace: WritableSignal<boolean>;
  public monitoring: WritableSignal<boolean>;
  public vendor: WritableSignal<boolean>;

  constructor()
  {
    this.catalog = signal<boolean>(false);
    this.library = signal<boolean>(false);
    this.servicesMatrix = signal<boolean>(false);
    this.spaceBot = signal<boolean>(false);
    this.security = signal<boolean>(false);
    this.tracker = signal<boolean>(false);
    this.marketplace = signal<boolean>(false);
    this.monitoring = signal<boolean>(false);
    this.vendor = signal<boolean>(false);
  }

  public static fromDto(dto: AppAvailabilityDto)
  {
    const app = new AppAvailability();
    app.catalog.set(dto.catalog);
    app.library.set(dto.library);
    app.servicesMatrix.set(dto.servicesMatrix);
    app.spaceBot.set(dto.spaceBot);
    app.security.set(dto.management)
    app.tracker.set(dto.tracker);
    app.marketplace.set(dto.marketplace);
    app.monitoring.set(dto.monitoring);
    // Stopgap (fail-open): backend AppAvailabilityDto does not yet return `vendor`,
    // so default to available to keep the vendor route/landing reachable in dev.
    // TODO: once the backend ships the flag, change to `app.vendor.set(dto.vendor)`
    // (fail-closed, like every other flag here). See docs/VENDOR_PORTAL_APIS_NEEDED.md #6.
    app.vendor.set(dto.vendor ?? true);
    return app;
  }

}